import { Helmet } from "react-helmet";
import Layout2 from "../layouts/Layout2";
import '../App.css';

const AppDownload = () => {
    return ( 
        <Layout2 pageType="အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ">
            <Helmet>
                <title>App Download</title>
            </Helmet>
            <div className="app-download-container">
                <div className="mb-4">
                    <img src="logo.png" className="app-logo" alt="Logo"></img>
                </div>
                <h2 className="download-title">အက်ပ်များကို ဒေါင်းလုဒ်လုပ်ပါ</h2>
                
                <div className="download-buttons">
                    <div className="download-row">
                        <a href='/ios-guide' className='download-btn ios'>
                            <i className='lni lni-apple'></i> iOS
                        </a>
                        <a href='https://office.pwaesargyipay.com/apk/pwaesargyipay1.apk' className='download-btn android' download>
                            <i className='lni lni-android'></i> Android App1
                        </a> 
                    </div>
                    <div className="download-row">
                        <a href='https://office.pwaesargyipay.com/apk/pwaesargyipay2.apk' className='download-btn android' download>
                            <i className='lni lni-android'></i> Android App2
                        </a> 
                        <a href='https://office.pwaesargyipay.com/apk/pwaesargyipay3.apk' className='download-btn android' download>
                            <i className='lni lni-android'></i> Android App3
                        </a> 
                    </div>
                </div>
                
                <div className="notice-text">
                    ⚠️ Android တွင် install မရပါက App 1, App 2, App 3 အား Install လုပ်ဆောင်ကြည့်ပါ
                </div>
            </div>
        </Layout2>
     );
}
 
export default AppDownload;